import React from 'react';
import { hot } from 'react-hot-loader';
import SearchForm from './SearchForm';
import SearchResults from './SearchResults';
import s from './Search.scss';

const Search = () => (
	<div className={s.search}>
		<SearchForm />
		<SearchResults />
	</div>
);

export default hot(module)(Search);
